import React, { FC, useState } from "react";
import ChatFormPanel from "../ChatFormPanel/ChatFormPanel";
import "./ChatBubble.less";

const ChatBubble: FC = () => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <button
                className="chat-bubble"
                onClick={() => setOpen((prev) => !prev)}
                aria-label={open ? "Lukk chat" : "Åpne chat"}
                type="button"
            >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32" fill="currentColor">
                    <path d="M20 2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h3l3.5 4.5a1 1 0 0 0 1.6-.1L15 18h5a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2ZM7 9a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm5 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z" />
                </svg>
            </button>
            <ChatFormPanel open={open} onOpenChange={setOpen} />
        </>
    );
};

export default ChatBubble;
